module.exports = __webpack_public_path__ + "static/media/ai-ad-massieMOBILE.176e5163.mp4";